// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "td[data-v-73f5200a]{line-height:1.42857143;vertical-align:middle}td[data-v-73f5200a]:not(:first-of-type){font-weight:700;padding:0 8px}td[data-v-73f5200a]:nth-of-type(2){width:50%}tr td[data-v-73f5200a]:first-of-type{width:1%}tr td:first-of-type .v-btn[data-v-73f5200a]{min-width:auto}.numbertd[data-v-73f5200a]{width:10rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
